import { createContext, useContext } from "react";

export type StakingView = "ACTIVE" | "ADJUSTING" | "REDEEM" | "NONE";

export type StakingViewAction = { type: "startAdjusting" | "cancelAdjusting" | "startRedeem"};

export type StakingViewContextType = {
  view: StakingView;

  // Indicates that a staking TX is pending.
  // The panel should be covered with a spinner overlay when this is true.
  changePending: boolean;

  // Dispatch an action that changes the Staking panel's view.
  dispatch: (action: StakingViewAction) => void;
};

export const StakingViewContext2 = createContext<StakingViewContextType | null>(null);

export const useStakingView = (): StakingViewContextType => {
  const context = useContext(StakingViewContext2);

  if (context === null) {
    throw new Error("You must add a <TroveViewProvider> into the React tree");
  }

  return context;
};
